<template>
  <div class="adderss-list-page" v-cloak>

    <van-nav-bar left-arrow fixed title="收货地址" id="nav-bar" @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon size="20" name="plus" />
      </template>
    </van-nav-bar>

    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="initData">
        <div class="adderss-radio" v-for="(item, index) in list" :key="index">
          <div class="adderss-action-item">
            <div class="adderss-action-name">
              <span class="moren" v-if="item.is_default == 1">默认</span>
              {{item.contacts}}
              <span class="adderss-action-phone">{{item.phone}}</span>
            </div>
            <div class="adderss-action-text">{{item.region}}</div>
            <div class="adderss-action-text fs">{{item.address}}</div>
          </div>
          <div class="edit" @click="goEdit(item)">
            编辑
          </div>
        </div>
      </van-list>

      <van-empty class="custom-image" v-if="list.length< 1" :image="noAdderss" />
      <div class="list-btn click" v-if="list.length< 1" @click="onClickRight()"> 添加地址 </div>

    </div>

  </div>
</template>

<script type="text/babel">
export default {
  name: "AdderssList",
  components: {},
  props: {},
  data() {
    return {
      noAdderss: require("../../assets/public/no-adderss.png"),
      list: [
        // {
        //   id: 0, //id
        //   prefixAddress: "string", //前置地址
        //   detail: "中煌⼤厦（放楼下⼤厅就可以）", //详细地址
        //   contactName: "百分百", //联系人姓名
        //   contactMobile: "15650421107",//联系人手机号码
        //   state: 0, //状态（1:默认地址）
        //   address: "上海市徐汇区枫林路街道中⼭南⼆路1007号" //地址
        // }, {
        //   id: 0, //id
        //   prefixAddress: "string", //前置地址
        //   detail: "中煌⼤厦（放楼下⼤厅就可以）", //详细地址
        //   contactName: "百分百", //联系人姓名
        //   contactMobile: "15650421107",//联系人手机号码
        //   state: 1, //状态（1:默认地址）
        //   address: "上海市徐汇区枫林路街道中⼭南⼆路1007号" //地址
        // },
      ],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      aa: {},
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 初始化数据
    initData() {
      let _this = this;

      this.$toast.loading();
      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
        uid: Lockr.get("userId"), // uid
      };
      this.$post("/api/user_address", data, data).then((res) => {
        this.loading = false; // 加载状态结束
        console.log(res.data.data);

        if (res.data.code == 0) {
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.list = lists;
            } else {
              _this.list = _this.list.concat(lists);
            }
            _this.pageNum++;

            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            this.finished = true; // 数据全部加载完成
          }
          this.$toast.clear();
        } else {
          this.$toast.fail(res.data.message);
          this.finished = true;
        }
      });
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({
        name: "adderss-edit",
        query: { isPage: 1 },
      });
    },
    goEdit(event) {
      console.log(event);
      this.$router.push({
        name: "adderss-edit",
        query: {
          isPage: 2,
          id: event.id,
          addsInfo:JSON.stringify(event),
        },
      });
    },
  },
};
</script>
<style lang="scss">
.adderss-list-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>
 
<style lang="scss" scoped>
.adderss-list-page {
  height: 100%;
  width: 100%;
  padding: 47px 10px;
  background-color: #f9f9f9;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE */
  scrollbar-width: none; /* Firefox */
}

.adderss-radio {
  text-align: left;
  width: 100%;
  height: 85px;
  background-color: #fff;
  margin: 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  .adderss-action-item {
    width: 280px;
    // background-color: peachpuff;
    border-right: 1px solid #cccccc;
  }
  .adderss-action-text {
    width: 100%;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 18px;
    color: #454f63;
    white-space: nowrap;
    /*内容超宽后禁止换行显示*/
    overflow: hidden;
    /*超出部分隐藏*/
    text-overflow: ellipsis;
    /*文字超出部分以省略号显示*/
  }
  .adderss-action-name {
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    /* line-height: 28rpx; */
    color: #2a2e43;
  }
  .adderss-action-phone {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    /* line-height: 28rpx; */
    color: #2a2e43;
  }
  .moren {
    padding: 1px 5px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 18px;
    color: #ffffff;
    background: #ff5000;
    border-radius: 3px;
    margin-right: 5px;
  }
  .edit {
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 14px;
    color: #78849e;
  }
}

.list-btn {
  width: 173px;
  height: 40px;
  margin: 0 auto;
  background: #ff510093;
  box-shadow: 0px 5px 15px rgba(3, 168, 192, 0.3);
  border-radius: 20px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
